module.exports = __webpack_public_path__ + "img/produce-4.5daf5b86.png";